import { FileText, Pin, ExternalLink } from "lucide-react";
import { resolveUrl } from "@/lib/api";

const isPdf = (a) => (a.type || "").toLowerCase() === "pdf" || (a.url || "").toLowerCase().includes(".pdf");

export const BoardCard = ({ post, big }) => {
  const atts = post.attachments || [];
  const images = atts.filter((a) => !isPdf(a));
  const pdfs = atts.filter(isPdf);
  const when = new Date(post.created_at).toLocaleString("sv-SE", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <div data-testid={`board-post-${post.id}`} className="mb-5 break-inside-avoid rounded-2xl border border-white/10 bg-[#14161A] overflow-hidden">
      {post.pinned && (
        <div className="flex items-center gap-1.5 bg-amber-500 px-4 py-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-black">
          <Pin className="w-3 h-3" /> Fäst
        </div>
      )}
      <div className={big ? "p-6" : "p-5"}>
        {post.title && <h3 className={`font-display font-black uppercase tracking-tight text-white leading-tight ${big ? "text-2xl" : "text-xl"}`}>{post.title}</h3>}
        {post.body && <p className={`mt-2 whitespace-pre-line text-white/75 leading-relaxed ${big ? "text-base" : "text-sm"}`}>{post.body}</p>}
        {images.length > 0 && (
          <div className={`mt-4 grid gap-2 ${images.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
            {images.map((a, i) => (
              <a key={i} href={resolveUrl(a.url)} target="_blank" rel="noreferrer" className="block">
                <img src={resolveUrl(a.url)} alt={a.name || "bild"} loading="lazy" className="w-full rounded-lg object-cover" />
              </a>
            ))}
          </div>
        )}
        {pdfs.map((a, i) => (
          <a key={i} href={resolveUrl(a.url)} target="_blank" rel="noreferrer"
            className="mt-3 flex items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 px-4 py-3 text-amber-400 hover:bg-amber-500/10 transition-colors">
            <FileText className="w-5 h-5 shrink-0" />
            <span className="flex-1 text-sm font-medium text-white truncate">{a.name || "PDF-dokument"}</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        ))}
        <div className="mt-4 font-mono text-[10px] uppercase tracking-widest text-white/35">{when}</div>
      </div>
    </div>
  );
};
